import { render, staticRenderFns } from "./GameOn.vue?vue&type=template&id=736d84c1&scoped=true&"
import script from "./GameOn.vue?vue&type=script&lang=js&"
export * from "./GameOn.vue?vue&type=script&lang=js&"
import style0 from "./GameOn.vue?vue&type=style&index=0&id=736d84c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d84c1",
  null
  
)

export default component.exports